import { render, staticRenderFns } from "./CommunicationTypeForm.vue?vue&type=template&id=3ff10af9&"
import script from "./CommunicationTypeForm.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports